import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* =======================
   MAIN PAGES
======================= */
import DensatHome from "./Component/DensatHome/DensatHome";
import Services from "./Component/Pages/Services";
import About from "./Component/Pages/About";
import Blogs from "./Component/Pages/Blogs";
import Contact from "./Component/Pages/Contact";
import Gallery from "./Component/Pages/Gallery";
import BlogDetails from "./Component/Blogs/BlogReading/BlogDetails";
import FPOComponent from "./Component/FPOPage/FPOComponent";

/* =======================
   CORPORATE PAGES
======================= */
import HouseCorporate from "./Component/CORPORATE/HouseCorporate";
import PantryCorporate from "./Component/CORPORATE/PantryServices/PantryCorporate";
import DeepCleaningCorporate from "./Component/CORPORATE/DeepCleaningServices/DeepCleaningCorporate";
import EngineeringTechnicalCorporate from "./Component/CORPORATE/EngineeringTechnicalMaintenance/EngineeringTechnicalCorporate";
import FacadeExternalCleaningCorporate from "./Component/CORPORATE/FacadeExternalCleaning/FacadeExternalCleaningCorporate";
import PestControlCorporate from "./Component/CORPORATE/CorporatePestControlServices/PestControlCorporate";
import EventCleaningCorporate from "./Component/CORPORATE/EventCleaning/EventCleaningCorporate";
import FrontOfficeCorporate from "./Component/CORPORATE/FrontOfficeHelpdeskManagement/FrontOfficeCorporate";
import GuestHouseCorporate from "./Component/CORPORATE/GuestHouseStaff/GuestHouseCorporate";
import IndustrialCorporate from "./Component/CORPORATE/IndustrialWarehouseCleaning/IndustrialCorporate";
import LandscapingCorporate from "./Component/CORPORATE/LandscapingHorticultureServices/LandscapingCorporate";
import ManpowerCorporate from "./Component/CORPORATE/ManpowerStaffingSolutions/ManpowerCorporate";

/* =======================
   ADMIN PAGES
======================= */
import AdminLogin from "./Component/Admin/Login/AdminLogin";
import AdminDashboard from "./Component/Admin/Dashboard/AdminDashboard";
import AdminUsers from "./Component/Admin/Users/AdminUsers";
import AdminSettings from "./Component/Admin/Settings/AdminSettings";
import AdminBlogs from "./Component/Admin/AdminBlogs/AdminBlogs";

/* =======================
   COMMON COMPONENTS
======================= */
import FloatingButtons from "./Component/FloatingButtons/FloatingButtons";
import Investmentadvisory from "./Component/Financial(FPO)/Investmentadvisory";
import KnowledgeKPO from "./Component/Financial(FPO)/KnowledgeKPO";
import PartTimeVirtualCFO from "./Component/Financial(FPO)/PartTimeVirtualCFO";
import EnterpriseRiskManagement from "./Component/Financial(FPO)/EnterpriseRiskManagement";
import AssetTagging from "./Component/Financial(FPO)/AssetTagging";
import RoutineFPO from "./Component/Financial(FPO)/RoutineFPO";

/* =======================
   NOT FOUND PAGE
======================= */
const NotFound = () => (
  <div style={{ padding: "80px", textAlign: "center" }}>
    <h1>404</h1>
    <p>Page not found</p>
  </div>
);

/* =======================
   ROUTER ROOT
======================= */
function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

/* =======================
   APP LAYOUT
======================= */
function AppLayout() {
  const location = useLocation();

  // Hide floating buttons on admin routes
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <FloatingButtons />}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<DensatHome />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/fpo" element={<FPOComponent />} />

        {/* Corporate Routes */}
        <Route path="/housekeeping" element={<HouseCorporate />} />
        <Route path="/corporate-pantryservices" element={<PantryCorporate />} />
        <Route path="/corporate-deepcleaning" element={<DeepCleaningCorporate />} />
        <Route path="/corporate-engineeringtechnical" element={<EngineeringTechnicalCorporate />} />
        <Route path="/corporate-facadeexternalcleaning" element={<FacadeExternalCleaningCorporate />} />
        <Route path="/corporate-pestcontrol" element={<PestControlCorporate />} />
        <Route path="/corporate-eventcleaning" element={<EventCleaningCorporate />} />
        <Route path="/corporate-frontoffice" element={<FrontOfficeCorporate />} />
        <Route path="/corporate-guesthouse" element={<GuestHouseCorporate />} />
        <Route path="/corporate-industrialwarehousecleaning" element={<IndustrialCorporate />} />
        <Route path="/corporate-landscaping" element={<LandscapingCorporate />} />
        <Route path="/corporate-manpowerstaffing" element={<ManpowerCorporate />} />
         <Route path="/investment-advisory" element={<Investmentadvisory/>} />
         <Route path="/Knowledgekpo" element={<KnowledgeKPO/>} />
        <Route path="/part-time-cfo-virtual-cfo" element={<PartTimeVirtualCFO/>} /> 
         <Route path="/enterprise-risk-management" element={<EnterpriseRiskManagement/>} /> 
          <Route path="/asset-tagging" element={<AssetTagging/>} /> 
        <Route path="/routine-fpo" element={<RoutineFPO/>} /> 
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/users/add" element={<AdminUsers />} />
        <Route path="/admin/users/edit/:id" element={<AdminUsers />} />
        <Route path="/admin/settings/*" element={<AdminSettings />} />
        <Route path="/admin/blogs" element={<AdminBlogs />} />

        {/* Catch-All (CRITICAL FOR SPA) */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
